import { useContext } from 'react';
import { AudioStockItem } from 'search-gateway-client';
import { twMerge } from 'tailwind-merge';

import { Tooltip } from '@videoblocks/design-system';

import StockItemCardContext from '../../cards/AudioStockItemCard/context/StockItemCardContext';
import { StockItemContext } from '../StockItemTypes';

export interface AudioAltVersionsButtonProps {
    stockItem: AudioStockItem;
    className?: string;
}

const AudioAltVersionsButton = ({ stockItem, className }: AudioAltVersionsButtonProps) => {
    const { stockItemContext } = useContext(StockItemCardContext);

    const { numCollapses = 0, collapsedSetId } = stockItem;
    if (stockItemContext !== StockItemContext.SEARCH || !collapsedSetId || numCollapses < 2) {
        return null;
    }
    const numberOfCollapses = numCollapses > 10 ? 10 : numCollapses - 1;

    return (
        <Tooltip
            title="More Versions"
            trigger={
                <div className="flex items-center h-fit">
                    <button
                        data-testid="expand-drawer"
                        title={`${numberOfCollapses} more version${numberOfCollapses > 1 ? 's' : ''}`}
                        className={twMerge(
                            'h-7 w-7 font-bold bg-gray-700 text-white rounded-full text-sm hidden lg:flex justify-center items-center hover:cursor-pointer',
                            className,
                        )}
                    >
                        +{numberOfCollapses}
                    </button>
                </div>
            }
        />
    );
};

export default AudioAltVersionsButton;
